import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { SquarespaceApiBrief } from '__generated__/SquarespaceApiBrief';
import { SquarespaceDesignerCard_User } from '__generated__/SquarespaceDesignerCard_User';
import { DesignerSource } from '__generated__/types';
import CardGrid from 'projects/components/CardGrid';
import { trackClickedShowMoreDesignersEvent, trackViewedDesignerEvent } from 'projects/events';
import React from 'react';
import AddDesignerButton from './AddDesignerButton';
import DesignerCard from './DesignerCard';

interface Props {
    brief: SquarespaceApiBrief;
}

interface State {
    pagesDisplayed: number;
    mergedDesignerResults: SquarespaceDesignerCard_User[];
}

export const NumTopMatches = 3;
export const DesignersPerPage = 15;

class SquarespaceDesignerResults extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const mergedDesignerResults = props.brief.designers.concat(
            props.brief.relevantDesigners.filter(
                designers => !props.brief.designers.some(d => d.id === designers.id)
            )
        );

        this.state = {
            pagesDisplayed: 1,
            mergedDesignerResults,
        };
    }

    get shownDesigners() {
        return this.state.mergedDesignerResults.slice(
            0,
            this.state.pagesDisplayed * DesignersPerPage
        );
    }

    hasMoreResults() {
        return this.shownDesigners.length < this.props.brief.relevantDesigners.length;
    }

    render() {
        const { brief } = this.props;
        const relevantDesignerIds = brief.relevantDesigners.map(designer => {
            return designer.id;
        });

        return (
            <div className="designer-results">
                <div className="designer-results__results">
                    <CardGrid>
                        {this.shownDesigners.map((user, i) => (
                            <DesignerCard
                                key={user.id}
                                user={user}
                                isSelected={brief.designers.some(({ id }) => id === user.id)}
                                onMount={() =>
                                    trackViewedDesignerEvent({
                                        id: brief.id,
                                        designer_id: user.id,
                                        designer_name: user.displayName,
                                        designer_level: user.profile.designerLevel,
                                        relevant_ranking: relevantDesignerIds.indexOf(user.id),
                                    })
                                }
                            >
                                <AddDesignerButton
                                    designer={user}
                                    position={relevantDesignerIds.indexOf(user.id)}
                                    designerSource={DesignerSource.RECOMMENDED}
                                />
                            </DesignerCard>
                        ))}
                    </CardGrid>
                </div>
                {this.hasMoreResults() && (
                    <div className="designer-results__pagination">
                        <Button
                            variations={['link']}
                            onClick={() => {
                                this.setState(
                                    state => ({
                                        pagesDisplayed: state.pagesDisplayed + 1,
                                    }),
                                    () => {
                                        trackClickedShowMoreDesignersEvent({
                                            id: brief.id,
                                            designers_per_page: DesignersPerPage,
                                            total_designers: this.shownDesigners.length,
                                        });
                                    }
                                );
                            }}
                        >
                            {__('Show more')}
                            <Icon type={'down-2'} variations={['offset-left']} />
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

export default SquarespaceDesignerResults;
